import styled from "styled-components";
import { FC } from "react";
import { LoadingSkeleton } from "../../Loader";

import * as typography from "../../../typography";

export enum DataTestIds {
  FirstLoadingRow = "data-first-loading-row",
  SecondLoadingRow = "data-second-loading-row",
}

const DataContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;

  max-width: 105px;
  gap: 4px;
  overflow: hidden;
`;

const Quantity = styled.div`
  ${typography.alpha.primaryActive.subtitle1}
  color: var(--color-primary-900);
`;
const Legend = styled.div`
  ${typography.alpha.primaryActive.caption}
  color: var(--color-primary-400);
`;
const Loading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  & > div {
    height: 12px;
    overflow: hidden;
  }
`;

type DataProps = {
  quantity: string;
  legend: string;
  isLoading?: boolean;
};

export const Data: FC<DataProps> = ({ quantity, legend, isLoading }) => (
  <DataContainer>
    {!isLoading ? (
      <>
        <Quantity>{quantity}</Quantity>
        <Legend>{legend}</Legend>
      </>
    ) : (
      <Loading>
        <LoadingSkeleton
          testId={DataTestIds.FirstLoadingRow}
          height={10}
          width={80}
        />
        <LoadingSkeleton
          testId={DataTestIds.SecondLoadingRow}
          height={10}
          width={80}
        />
      </Loading>
    )}
  </DataContainer>
);
